module.exports = __webpack_public_path__ + "static/media/clientJobActive.69274459.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clientJobActive.svg
// module id = 1019
// module chunks = 1